import { aboutData } from '@/mocks/chiguaHomeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            关于吃瓜在线
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            了解51国产吃瓜在线今日吃瓜第一平台
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-background-50 rounded-2xl p-6 md:p-10">
            <div className="space-y-5 text-sm md:text-base text-foreground-700 leading-relaxed">
              {aboutData.paragraphs.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-10">
              {aboutData.stats.map((stat, i) => (
                <div key={i} className="text-center p-4 rounded-xl bg-background-100">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500 mb-1">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}